import { ActionType } from '@superbet-group/web.types';

/**
 * Banners are commercials that fill empty spaces across the app.
 * Click on every banner triggers an action. Action can be:
 * 1) open link in new tab
 * 2) open new popup window
 * 3) open in app link
 */

export type Banner = BannerLegacy | BannerDirectus;

export type BannerVariant = 'primary' | 'primary-alt' | 'secondary' | 'secondary-alt' | 'secondary-alt-2' | 'tertiary' | 'tertiary-alt' | 'napoleon-primary' | 'napoleon-secondary';

export interface BannerLegacy extends BaseBanner {
    kind: 'legacy';
}

export interface BannerDirectus extends BaseBanner {
    kind: 'directus';
    startDate: Date;
    endDate: Date;
    showToLoggedInUsers: boolean;
    showToLoggedOutUsers: boolean;
    showToNewUsersDevice: boolean;
    showToReturningUsersDevice: boolean;
    variant: BannerVariant;
    buttonText: string;
    iconName: string | null;
}

interface BaseBanner {
    id: string;
    title: string;
    description: string;
    image: string | null;
    backgroundImage: string | null;
    link: string;
    linkDescription: string;
    // used so we can distinguish what to do with the link
    actionType: ActionType;
    step?: number;
}

export function isBannerDirectusArray(banners: Banner[]): banners is BannerDirectus[] {
    return banners.every((banner) => banner.kind === 'directus');
}
